import React, { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import './App.css';
import abi from './utils/WavePortal.json';

const App = () => {
  const [currentAccount, setCurrentAccount] = useState('');

  const [allWaves, setAllWaves] = useState([]);

  const [sendMessage, setSendMessage] = useState('');

  const contractAddress = '0x72fD41e8798943913dFEeEc77F3C4cf47FaB88AB';

  const clearMessage = () => {
    document.getElementById('output').value = '';
  };

  const contractABI = abi.abi;

  const getAllWaves = async () => {
    const { ethereum } = window;

    try {
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const wavePortalContract = new ethers.Contract(
          contractAddress,
          contractABI,
          signer
        );
        const waves = await wavePortalContract.getAllWaves();

        const wavesCleaned = waves.map((wave) => {
          return {
            address: wave.waver,
            timestamp: new Date(wave.timestamp * 1000),
            message: wave.message,
          };
        });

        setAllWaves(wavesCleaned);
      } else {
        console.log("Ethereum object doesn't exist!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * Listen in for emitter events!
   */
  useEffect(() => {
    let wavePortalContract;

    const onNewWave = (from, timestamp, message) => {
      console.log('NewWave', from, timestamp, message);
      setAllWaves((prevState) => [
        ...prevState,
        {
          address: from,
          timestamp: new Date(timestamp * 1000),
          message: message,
        },
      ]);
    };

    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      wavePortalContract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );
      wavePortalContract.on('NewWave', onNewWave);
    }

    return () => {
      if (wavePortalContract) {
        wavePortalContract.off('NewWave', onNewWave);
      }
    };
  }, []);

  const checkIfWalletIsConnected = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        console.log('Make sure you have metamask!');
        return;
      } else {
        console.log('We have the ethereum object', ethereum);
      }

      const accounts = await ethereum.request({ method: 'eth_accounts' });

      if (accounts.length !== 0) {
        const account = accounts[0];
        console.log('Found an authorized account:', account);
        setCurrentAccount(account);
      } else {
        console.log('No authorized account found');
      }
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * Implement your connectWallet method here
   */
  const connectWallet = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        alert('Get MetaMask!');
        return;
      }

      const accounts = await ethereum.request({
        method: 'eth_requestAccounts',
      });

      console.log('Connected', accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const wave = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const wavePortalContract = new ethers.Contract(
          contractAddress,
          contractABI,
          signer
        );

        let count = await wavePortalContract.getTotalWaves();
        console.log('Retrieved total wave count...', count.toNumber());

        /*
         * Execute the actual wave from your smart contract
         */
        const waveTxn = await wavePortalContract.wave(sendMessage, {
          gasLimit: 300000,
        });
        console.log('Mining...', waveTxn.hash);

        await waveTxn.wait();
        console.log('Mined -- ', waveTxn.hash);

        count = await wavePortalContract.getTotalWaves();
        console.log('Retrieved total wave count...', count.toNumber());
        clearMessage();
      } else {
        console.log("Ethereum object doesn't exist!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkIfWalletIsConnected();
    getAllWaves();
  }, [getAllWaves]);

  allWaves.sort((a, b) => {
    return b.timestamp - a.timestamp;
  });

  return (
    <div className="mainContainer">
      <div className="dataContainer">
        <div className="header">👋 Hey there!</div>
        <div className="bio">
          I am Deriboss and I am a beginner in Web Dev, looking forward to learn
          more about Web2 and Web3. Connect your Ethereum wallet and wave at me!
        </div>
        {currentAccount ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px',
            }}
          >
            <textarea
              name=""
              id="output"
              cols="30"
              rows="10"
              placeholder="Enter your message..."
              style={{
                resize: 'none',
                outline: 'none',
                width: '70%',
                height: '25vmin',
                padding: '10px',
              }}
              onChange={(e) => setSendMessage(e.target.value)}
            ></textarea>
          </div>
        ) : null}
        <button className="waveButton" onClick={wave}>
          Wave at Me
        </button>
        {/*
         * If there is no currentAccount render this button
         */}
        {!currentAccount && (
          <button className="waveButton" onClick={connectWallet}>
            Connect Wallet
          </button>
        )}
        {currentAccount ? (
          <h2 style={{ marginTop: '40px' }}>Check Out Previous Waves 👇👇</h2>
        ) : null}
        {allWaves.map((wave, index) => {
          return (
            <div key={index} className="allWavesContainer">
              <div className="headDiv">
                <p className="headings">Address</p>
                <p>
                  <a
                    href={`https://rinkeby.etherscan.io/address/${wave.address}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: 'none',
                      color: 'blue',
                    }}
                  >
                    {wave.address.slice(0, 4)}...{wave.address.slice(38)}
                  </a>
                </p>
              </div>
              <div className="headDiv">
                <p className="headings">Time</p>
                <p>
                  {new Date(wave.timestamp).toLocaleString('en-US', {
                    // timeZone: 'Africa/Lagos',
                    hour12: true,
                    timeStyle: 'short',
                    dateStyle: 'long',
                  })}
                </p>
              </div>
              <div className="headDiv">
                <p className="headings">Message</p>
                <p>{wave.message}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default App;
